var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocationIcon = function SvgLocationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-942.000000, -201.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M931.001986,195.236914 L934.041284,189.602695 C934.489928,188.756328 934.727213,187.798906 934.727213,186.83332 C934.727252,183.616797 932.158075,181 929,181 C925.841925,181 923.272748,183.616797 923.272748,186.83332 C923.272748,187.798906 923.510072,188.756328 923.960288,189.605117 L926.998091,195.236875 C924.315775,195.410273 920,196.01082 920,198.08332 C920,200.918203 928.078741,201 929,201 C929.921259,201 938,200.918203 938,198.08332 C938,196.01082 933.684302,195.410313 931.001986,195.236914 Z M925.72729,186.83332 C925.72729,184.995352 927.195451,183.5 929,183.5 C930.804549,183.5 932.27271,184.995352 932.27271,186.83332 C932.27271,188.671289 930.804549,190.166641 929,190.166641 C927.195451,190.166641 925.72729,188.671289 925.72729,186.83332 Z M929,199.33332 C924.977428,199.33332 922.339485,198.584219 921.721478,198.08332 C922.279426,197.631094 924.487938,196.978477 927.871179,196.855547 L928.641675,198.283906 C928.713202,198.417383 928.850618,198.499961 929.000038,198.499961 C929.149459,198.499961 929.286875,198.417344 929.358401,198.283906 L930.128936,196.855547 C933.512138,196.978477 935.720613,197.631094 936.278561,198.08332 C935.660515,198.584219 933.022572,199.33332 929,199.33332 Z",
    id: "Location"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-icon.d7a7e4b1.svg";
export { ForwardRef as ReactComponent };